<script>
import Folder from '@wielink-application/shared/vue/layouts/partials/sidebar/folder.vue'
export default Folder;
</script>